<template>
  <van-popup
    v-model="show"
    position="bottom"
    :style="{ height: height }"
  >
    <div class="dealer-container" :class="tips ? 'dealer-container-max' : ''">
      <form action="/" class="search-container">
        <div class="search-wrap">
          <div class="content">
            <van-search
              v-model="dealerName"
              :left-icon="require('@/assets/images/cars/nav_search.png')"
              class="search-field"
              placeholder="请输入经销商名称"
              @search="onSearch"
            />
          </div>
          <div style="width: 30px;margin-left: 10px;" @click="show=false"> 退出</div>
          <!-- <text class="cancel">取消</text> -->
        </div>
        <p v-if="tips" class="tips">{{ tips }}</p>
      </form>
      <section class="list-wrap">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <div v-if="!isArea" class="area-tips">
            您搜索的区域内没有经销商
            <p>已为您推荐距离您最近的其他经销商</p>
          </div>
          <van-list
            v-model="loading"
            error-text="请求失败，点击重新加载"
            :finished="finished"
            :finished-text="dataList.length ? '没有更多了' : ''"
            style="padding-bottom: 24px;"
            @load="onLoad"
          >
            <div v-for="(item,index) in dataList" :key="index" class="list-item" @click="selectDealer(item)">
              <div class="info">
                <p class="name">{{ item.dealerName }}</p>
                <p class="address">{{ item.address || '' }}</p>
                <div class="call">
                  <div style="display: inline-flex;align-items: center;">
                    <nx-image class="call-icon" width="17px" :src="require('@/assets/images/cars/icon_call_phone.png')"></nx-image>
                    {{ item.fullTimeHotLine || '/' }}
                  </div>
                  距您{{ item.distance }}{{ item.distance > 1 ? 'km' : 'm' }}
                </div>

              </div>
              <!-- <view class="copy">
            <image class="copy-icon" :src="require('@/assets/images/cars/copy-icon.png')"></image>
            复制
          </view> -->
            </div>
          </van-list>
        </van-pull-refresh>
      </section>
    </div>
  </van-popup>
</template>
<script>
import {
  getDealer4SListPage,
} from '@/api/cars/dealer';
import { getCurrentLocation } from '@/utils/map';

export default {
  name: 'NxSelectdealer',
  props: {
    // 业务类别1试乘试驾2预约维保
    businesType: {
      type: [String, Number],
      default: '',
    },
    // 经销商类型 1、电车 2、油车 3、油电双授权
    dealerType: {
      type: [Number, String],
      default: '',
    },
    // 	0售前， 1售后
    serviceType: {
      type: [Number, String],
      default: '',
    },
    // 服务店类型0销服一体;1单一服务;2单一销售
    type: {
      type: [Number, String],
      default: '',
    },
    // popup高度，默认100%全屏，80%半屏
    height: {
      type: [String],
      default: () => '100%',
    },
    // 列表是否需要过滤可预约条件
    isReservation: {
      type: Boolean,
      default: () => false,
    },
    // 经销商列表底部提示文案
    tips: {
      type: [String],
      default: () => '',
    },
  },
  data() {
    return {
      isArea: false,
      finished: false,
      loading: false,
      refreshing: false, // 下拉刷新
      page: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      dealerName: '',
      dataList: [],
      location: {
        lng: '', // 经度,纬度
        lat: '',
      },
      cityObj: null,
      show: false,
    };
  },
  watch: {
    location: {
      deep: true,
      handler(location) {
        if (location.lng && location.lat) {
          this.onSearch();
        }
      },
    },
  },
  created() {
    this.getLocation();
  },
  methods: {
    async getLocation() {
      this.location = await getCurrentLocation();
    },
    /**
     * 打开选项弹窗
     * @param {[
     *  province: string,
     *  city: string,
     *  district: string
     * ]} city
     */
    open(city) {
      this.show = true;
      this.cityObj = city;

      this.onSearch();
    },
    onSearch() {
      this.page.pageIndex = 1;
      this.onLoad();
    },
    onRefresh() {
      this.page.pageIndex = 1;
      this.dataList = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    selectDealer(item) {
      this.show = false;

      this.$emit('dealer', item);
    },
    async onLoad() {
      console.log(this.cityObj);
      this.loading = true;
      if (this.refreshing) {
        this.dataList = [];
        this.refreshing = false;
      }

      const [
        province = '', // 身份中文名
        city = '', // 业务分区中文名
        district = '', // 行政区中文名
      ] = this.cityObj || [];
      const { pageIndex, pageSize } = this.page;
      const { lng, lat } = this.location;
      const params = {
        pageIndex,
        pageSize,
        dealerName: this.dealerName,
        province,
        city,
        district,
        latitude: lat,
        longitude: lng,
        serviceType: this.serviceType,
        type: this.type,
      };
      if (this.businesType) {
        params.businesType = this.businesType;
      }
      if (this.dealerType) {
        params.dealerType = this.dealerType;
      }
      if (this.isReservation) {
        params.isReservation = 1;
      }
      const { data: { dataList, page, isArea }} = await getDealer4SListPage(params);
      dataList.forEach(v => {
        v.distance = v.distance || 0;
      });
      this.isArea = isArea;
      this.loading = false;
      this.dataList = pageIndex > 1 ? this.dataList.concat(dataList || []) : dataList;
      this.page.total = page.totalCount;
      this.page.pageIndex += 1;
      if (this.dataList.length >= this.page.total) {
        // 数据全部加载完成
        this.finished = true;
        this.loading = false;
      }
    },
  },
};
</script>
  <style lang="scss">
  .search-wrap{
    .search-field{
      padding: 0;
      background-color: initial;
      padding:0;
      width: 100%;
      .van-cell{
        padding:0;
      }
      .van-search__content{
        background: inherit;
        padding-left:0;
      }
      .van-field__left-icon{
        display: inline-flex;
        align-items: center;
        margin-right:12px;
      }
    }
  }
  </style>
  <style lang="scss" scoped>
  .dealer-container{
    height: 100%;
    background: #F6F8FA;
  }
  .dealer-container-max{
    .search-container{
      height: 95px !important;
    }
    .search-wrap{
      padding: 12px 18px 0 !important;
    }
    .list-wrap{
      height: calc(100% - 95px) !important;
    }
  }
  .search-container{
    background: #fff;
    .tips{
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      text-align: center;
    }
  }
  .search-wrap{
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background: #fff;
  }
  .search-wrap .content{
    width: 100%;
    height: 36px;
    background:rgba(153, 153, 153, 0.2);
    border-radius: 18px;
    padding: 0px 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .search-wrap .phcolor{
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
  .search-field{
    padding: 0;
    background-color: initial;
    padding:0;
  }
  .search-wrap .content input{
    width: calc(100%  - 40px);
  }
  .search-wrap .search-icon{
    margin-right: 12px;
  }
  .search-wrap .cancel{
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 22px;
  }
  .list-wrap{
    height: calc(100% - 68px);
    overflow: auto;
  }
  .list-item{
    margin: 12px 0;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px 18px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background: #fff;
  }
  .list-item .info{
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    width: 100%;
    word-break: break-all;
  }
  .list-item .name{
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    line-height: 22px;
  }
  .list-item .address{
    margin: 6px 0;

  }
  .list-item .call{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .list-item .call .call-icon{
    width: 17px;
    height: 17px;
    margin-right: 9px;
  }
  .list-item .copy{
    font-size: 12px;
    font-weight: 500;
    color: #0450B4;
    display: flex;
    align-items: center;
  }
  .list-item .copy .copy-icon{
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }
  .area-tips{
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    text-align: center;
    margin-top: 12px;
  }
  </style>

